import { gql } from '@apollo/client';

/**
 * Fetches all credit submissions for a given Dynamics Vendor Opportunity ID,
 * including the fields needed to render the Compare Approvals table.
 *
 * The caller is responsible for filtering to only "Approved" / "Pre-Approved"
 * stages before displaying results.
 */
export const GET_APPROVALS_BY_VENDOR_OPPORTUNITY_ID = gql`
  query GetApprovalsByVendorOpportunityId($voId: ID!) {
    creditSubmissionsByDynamicsVOId(id: $voId) {
      creditSubmissionId
      lenderName
      approvedAmount
      approvedRate
      stage
      decision
      contingencies
      creditDecisionParsedData {
        parsedDecisionId
        parsedData {
          conditions
          decisionType
          firstPaymentDueDate
          decisionDate
          declineReasons
          interestRate
          lenderFees {
            amount
            canBeFinanced
            description
            feeName
          }
          stipulations
          termLengthMonths
          advancePaymentsCount
          approvalAmount
          expirationDate
          applicantName
          businessName
          monthlyPayment
          downPaymentToVendor
        }
      }
      proposals {
        proposalId
        status
        termLength
        monthlyPayment
        maxApprovedAmount
        docFee
        rate
        interestRate
        __typename
      }
      __typename
    }
  }
`;

export const UPDATE_PARSED_DECISION = gql`
  mutation UpdateParsedDecision($input: UpdateParsedDecisionInput!) {
    updateParsedDecision(input: $input) {
      parsedDecisionId
      reviewStatus
      modifiedDateTime
      reviewNotes
      parsedData {
        decisionType
        decisionDate
        approvalAmount
        termLengthMonths
        interestRate
        monthlyPayment
        downPaymentToVendor
        conditions
        stipulations
        lenderFees {
          feeName
          amount
          canBeFinanced
          description
        }
        applicantName
        businessName
      }
    }
  }
`;
